export default "__VITE_ASSET__e0303fb2__"